module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-72969f37.png";